import React from 'react';

import { AcknowledgementRequestStatus } from 'utils/api/modules/entities/entities.types';

import { StyledMenuItem, StyledSelect } from '../styles';
import { ACK_REQUEST_STATUS_LABELS } from './types';

interface AcknowledgementStatusSelectProps {
  value: AcknowledgementRequestStatus | null;
  onChange: (value: AcknowledgementRequestStatus) => void;
}

const OPTIONS: AcknowledgementRequestStatus[] = [
  AcknowledgementRequestStatus.Active,
  AcknowledgementRequestStatus.Completed,
  AcknowledgementRequestStatus.Cancelled,
];

const AcknowledgementStatusSelect: React.FunctionComponent<AcknowledgementStatusSelectProps> = ({
  onChange,
  ...props
}) => (
  <StyledSelect {...props} fullWidth onChange={(event) => onChange(event.target.value as AcknowledgementRequestStatus)}>
    {OPTIONS.map((status) => (
      <StyledMenuItem key={status} value={status}>
        {ACK_REQUEST_STATUS_LABELS[status]}
      </StyledMenuItem>
    ))}
  </StyledSelect>
);

export default AcknowledgementStatusSelect;
